<style scoped>
	#body {
		margin: 5px;
		border-radius: 5px;
		display: flex;
		flex-direction: column;
		font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
	}
	
	.el-form-item {
		margin-bottom: 0px;
	}
</style>

<template>
	<div id="body">
		<div style="box-shadow: 1px 1px 10px #DCDCDC; height: 40px; background-color: white; display: flex; flex-direction: row; align-items: center; margin: 0 10px; padding: 5px 5px 5px 20px; border-radius: 10px;">
			<el-button icon="el-icon-refresh-right" circle  @click="refresh" style="margin-right: 20px;"></el-button>
			
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item>首页</el-breadcrumb-item>
			  <el-breadcrumb-item>用户管理</el-breadcrumb-item>
			  <el-breadcrumb-item>代理列表</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div style="margin-top: 10px; background-color: white; padding: 10px; margin: 10px; border-radius: 5px;">
			<div style="display: flex; flex-direction: row; justify-content: space-between; width: 100%; margin-bottom: 10px;">
				<el-form :inline="true" :model="searchForm" class="demo-form-inline">
					<el-form-item label="" style="width: 140px;">
						<el-select v-model="searchForm.status" placeholder="账号状态" clearable>
							<el-option label="所有账号状态" value=""></el-option>
							<el-option label="账号正常" value="1"></el-option>
							<el-option label="账号禁用" value="0"></el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="" style="width: 140px;">
						<el-select v-model="searchForm.is_service" placeholder="客服状态" clearable>
							<el-option label="所有客服状态" value=""></el-option>
							<el-option label="显示客服" value="1"></el-option>
							<el-option label="隐藏客服" value="0"></el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="">
						<el-input v-model="searchForm.keyword" placeholder="代理编号/账号/昵称"></el-input>
					</el-form-item>
					
					<el-form-item>
						<el-button type="primary" @click="onSubmit">搜索查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="danger" @click="addAgentView=true">创建代理</el-button>
					</el-form-item>
				</el-form>
			</div>
			<el-table :data="tableData" border  style="width: 100%" 
					v-loading="loading"
					element-loading-text="拼命加载中"
					element-loading-spinner="el-icon-loading"
					element-loading-background="rgba(0, 0, 0, 0.8)" >
				<el-table-column prop="aid" label="编号" width="100"  align="center"></el-table-column>
				<el-table-column prop="nickname" label="代理昵称" width="200"  align="center"></el-table-column>
				<el-table-column prop="username" label="代理账号" width="180"  align="center"></el-table-column>
				<el-table-column prop="hour_price" label="充值USDT/天" width="140"  align="center"></el-table-column>
				<el-table-column prop="hour_balance" label="帐户剩余天数" width="140"  align="center"></el-table-column>
				<el-table-column prop="is_service" label="客服" width="100"  align="center">
					<template slot-scope="scope">
						<el-button v-if="scope.row.is_service==0" @click="SchangeStatus(scope)" size="mini">隐藏</el-button>
						<el-button v-if="scope.row.is_service!=0" @click="SchangeStatus(scope)" type="primary" size="mini">显示</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="add_time" label="创建时间" align="center" width="200"></el-table-column>
				<el-table-column prop="status" label="状态"  align="center"  width="100">
					<template slot-scope="scope">
						<el-button v-if="scope.row.status==0" @click="changeStatus(scope)" size="mini">禁用</el-button>
						<el-button v-if="scope.row.status!=0" @click="changeStatus(scope)" type="primary" size="mini">正常</el-button>
					</template>
				</el-table-column>
			
				<el-table-column fixed="right" label="操作" align="center" width="500">
					<template slot-scope="scope">
						<el-button @click="changeBalanceFunc(scope)" type="danger"  size="mini" >加减时长</el-button>
						<el-button @click="ViewBalance(scope.row.aid)" type="success"  size="mini" >账户明细</el-button>
						<el-button @click="ViewChild(scope.row.aid)" type="primary"  size="mini" >查看下级会员</el-button>
						<el-button @click="EditUser(scope.row)" type="info" size="mini">编辑查看</el-button>
						<el-button @click="Dele(scope)" type="danger" size="mini">删除</el-button>
					</template>
				</el-table-column>
				
			</el-table>
			<el-pagination background layout="prev, pager, next" :key="tableKey" :page-size="limit" @current-change="getData" :total="total" style="margin-top: 20px;"></el-pagination>
		</div>
		
		<el-dialog title="编辑查看" :visible.sync="editView" width="1000px" @close="editView=false":close-on-click-modal="false">
			<editAgent @close-dialog="editView=false" :userInfo="userInfo"></editAgent>
		</el-dialog>
		
		<el-dialog title="查看流水" :visible.sync="balanceView" width="1300px" @close="balanceView=false":close-on-click-modal="false">
			<userBalance :uid="balance_uid"></userBalance>
		</el-dialog>
		
		<el-dialog title="添加代理" :visible.sync="addAgentView" width="800px" @close="addAgentView=false":close-on-click-modal="false">
			<addAgent @close-dialog="addUserClose"></addAgent>
		</el-dialog>
		
		<el-dialog title="加减时长" :visible.sync="changeBalance" width="800px" @close="changeBalance=false":close-on-click-modal="false">
			<PayHand :userinfo="userInfo"></PayHand>
		</el-dialog>
		
		<el-dialog title="查看下级会员" :visible.sync="ChildView" width="90%" @close="ChildView=false":close-on-click-modal="false">
			<ChildUserList :aid="balance_uid"></ChildUserList>
		</el-dialog>
		
	</div>
</template>

<script>
	import editAgent from './editAgent.vue';
	import userBalance from './userBalance.vue';
	import addAgent from './addAgent.vue';
	import PayHand from './PayHand.vue';
	import ChildUserList from './ChildUserList.vue';
	
	export default {
		components:{
			editAgent, userBalance, addAgent,PayHand, ChildUserList
		},
		name:'List',
		data(){
			return {
				ChildView:false,
				changeBalance:false,
				addHourView:false,
				addAgentView:false,
				balance_uid:0,
				userInfo:{},
				balanceView:false,
				editView:false,
				tableKey:0,
				loading:false,
				limit:10,
				total:0,
				searchForm:{
					status:"",
					keyword:"",
					is_service:""
				},
				tableData: []
			}
		},
		created() {
			this.getData(1);
		},
		methods:{
			addUserClose(){
				this.addAgentView = false;
				this.getData(1);
			},
			changeBalanceFunc(scope){
				this.userInfo = scope.row;
				this.changeBalance = true;
			},
			DeleApi(scope){
				let _this = this;
				let user = scope.row;
				_this.$api.post("/User/DeleteAgent", {aid:user.aid}).then(res=>{
					if(res.code == 1){
						_this.tableData.splice(scope.$index, 1);
					}else{
						_this.$message({ message: '操作失败', type: 'warning' });
					}
				}).catch(res=>{
				});
			},
			Dele(scope){
				this.$confirm('是否确认删除此代理账号?? [删除后所有代理下级会员归属平台总账户!!]', '提示', {confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'}).then(() => {
					this.DeleApi(scope);
				}).catch(() => {
				});
			},
			SchangeStatus(scope){
				let _this = this;
				let user = scope.row;
				let _status = user.is_service == 0 ? 1 : 0;
				_this.$api.post("/User/editAgentServiceStatus", {aid:user.aid, status:_status}).then(res=>{
					if(res.code == 1){
						_this.$message({ message: '操作成功', type: 'success' });
						_this.tableData[scope.$index].is_service = _status;
					}else{
						_this.$message({ message: '操作失败', type: 'warning' });
					}
				}).catch(res=>{
				});
			},
			changeStatus(scope){
				let _this = this;
				let user = scope.row;
				let _status = user.status == 0 ? 1 : 0;
				_this.$api.post("/User/editAgentStatus", {aid:user.aid, status:_status}).then(res=>{
					if(res.code == 1){
						_this.$message({ message: '操作成功', type: 'success' });
						_this.tableData[scope.$index].status = _status;
					}else{
						_this.$message({ message: '操作失败', type: 'warning' });
					}
				}).catch(res=>{
				});
			},
			ViewChild(_uid){
				this.balance_uid = _uid;
				this.ChildView = true;
			},
			addHourFunc(_uid){
				this.balance_uid = _uid;
				this.addHourView = true;
			},
			ViewBalance(_uid){
				this.balance_uid = _uid;
				this.balanceView = true;
			},
			EditUser(row){
				console.log(row);
				this.userInfo = row;
				this.userInfo.password = '';
				this.editView = true;
			},
			formatTimestamp(targetTimeString) {
			  // 获取当前时间的时间戳
			  const currentTime = new Date().getTime();
			  
			  // 将目标时间字符串转换为时间戳
			  const targetTime = new Date(targetTimeString).getTime();
			  
			  // 计算两个时间戳之间的毫秒差值
			  const timeDifference = targetTime - currentTime;
			  
			  // 将毫秒差值转换为天数，并保留1位小数
			  const daysDifference = (timeDifference / (1000 * 60 * 60 * 24)).toFixed(1);
			  
			  return parseFloat(daysDifference); // 返回浮点数类型的天数
			},
			refresh(){
				this.getData(1);
				this.tableKey +=1;
			},
			getData(page){
				let that = this;
				that.loading = true;
				that.$api.post("/User/AgentList", {page:page, status:that.searchForm.status, is_service:that.searchForm.is_service, keyword:that.searchForm.keyword}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
				}).catch(res=>{
					that.loading = false;
				});
			},
			handleClick(e){
			},
			onSubmit(){
				this.getData(1);
			}
		}
	}
</script>